var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('p',{staticClass:"text-center text-gray-500 text-xs py-8"},[_vm._v(" "+_vm._s(_vm.$t("marketing.footer.copyright"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }